module.exports = __webpack_public_path__ + "img/placeOrder.03e2cfd.png";